import { useEffect } from 'react';
import { dateWithTimeZone } from "../../../../../utilities/utils";

const utmCampaignValue = 'hardsellbrandmand';
const utmSourceValue = 'phd';

const BrandmanPixel = ({ model }) => {
  useEffect(() => {
    let expirationDate = new Date("2025-04-01");//YYYY-MM-DD
    const utmCampaign = sessionStorage.getItem("utm_campaign");
    const utmSource = sessionStorage.getItem("utm_source");
    const dynamicCode = Math.random().toString(36).substring(2, 10);

    if( dateWithTimeZone() < expirationDate && utmCampaign === utmCampaignValue && utmSource === utmSourceValue ) {
      if (model?.name === 'Q3') {
          const imgPixel  = document.createElement('img');
          imgPixel.src    = `https://brandmandco.lnjmp.com/pixel.track?CID=471106&p=img&MerchantReferenceID=${dynamicCode}`;
          imgPixel.width  = 1;
          imgPixel.height = 1;
          imgPixel.border = 0;
          imgPixel.style  = 'display: none';
          imgPixel.id     = `phd-brandman-pixel-script-${model.name}`;
        
          document.body.appendChild(imgPixel);
      }

      if (model?.name === 'Q5') {
        const imgPixel  = document.createElement('img');
        imgPixel.src    = `https://brandmandco.lnjmp.com/pixel.track?CID=471445&p=img&MerchantReferenceID=${dynamicCode}`;
        imgPixel.width  = 1;
        imgPixel.height = 1;
        imgPixel.border = 0;
        imgPixel.style  = 'display: none';
        imgPixel.id     = `phd-brandman-pixel-script-${model.name}`;
        
        document.body.appendChild(imgPixel);
      }
    }
  }, [model]);

  return (<></>);
};

export default BrandmanPixel;